import { Component, Input, OnInit } from '@angular/core';
import { BadgeDefinitionDTO } from '../../../../interfaces/gamification/badge-definition.dto';

@Component({
  selector: 'badge-progress-circle',
  templateUrl: 'badge-progress-circle.component.html',
  styleUrls: ['badge-progress-circle.component.scss'],
})
export class BadgeProgressCircleComponent implements OnInit {
  constructor() {}

  _progress: number;
  @Input('progress') // percentage between 0 and 100 (will be constrained)
  public set progress(value: number) {
    this._progress = Math.min(Math.max(value, 0), 100);
    this.setDegrees();
  }
  public get progress(): number {
    return this._progress;
  }

  degrees: number = 0;

  @Input() badge: BadgeDefinitionDTO;
  @Input() moves: number;

  ngOnInit() {}

  setDegrees() {
    this.degrees = 180.0 * (this._progress / 100.0);
  }
}
